<ng-container
  *ngIf="{
    semanticRoute: semanticRoute$ | async,
    logoPath: tabbar ? 'assets/v2/images/tabbar-logo.svg' : 'assets/v2/images/logo-header.svg',
  } as obs"
>
  @if (obs.semanticRoute === 'home') {
    <img [src]="obs.logoPath" (click)="scrollToTop()" />
  } @else {
    <a routerLink="/">
      <img [src]="obs.logoPath" />
    </a>
  }
</ng-container>
